const feedsInputs = {
  marginBottom: '10px',
};

export default { feedsInputs };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/News/components/TextInput/style.js